import { render, staticRenderFns } from "./sad-builder-col.vue?vue&type=template&id=731cb332&"
import script from "./sad-builder-col.vue?vue&type=script&lang=js&"
export * from "./sad-builder-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports